import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "../helpers/JsonMapper";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Pagination extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Pagination.current_page_attribute_name]: 0,
      [Pagination.data_attribute_name]: [],
      [Pagination.per_page_attribute_name]: 5,
      [Pagination.total_attribute_name]: 0
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getCurrentPageAttributeName() {
    return Pagination.current_page_attribute_name;
  }
  static getPerPageAttributeName() {
    return Pagination.per_page_attribute_name;
  }
  static getDataAttributeName() {
    return Pagination.data_attribute_name;
  }
  static getTotalAttributeName() {
    return Pagination.total_attribute_name;
  }
}
_defineProperty(Pagination, "current_page_attribute_name", 'current_page');
_defineProperty(Pagination, "data_attribute_name", 'data');
_defineProperty(Pagination, "per_page_attribute_name", 'per_page');
_defineProperty(Pagination, "total_attribute_name", 'total');